module.exports = __webpack_public_path__ + "static/bg.146b5127.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/support-organisations/bg.svg
// module id = 3740
// module chunks = 61022679780615